import React, { useEffect, useState, useRef } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchRateAdminRates,
  initializeRateAdminRatesScreen,
  setDeleteConfirmationPopupVisibility,
  exportRateAdminRates,
  fetchRateAdminRatesDD,
  fetchRateAdminNetworkDD,
  fetchRateAdminRateOptionsDD,
  deleteRateAdminRates,
  saveRatesTableState,
  fetchRateAdminRatesById,
  fetchRateAdminRatesRateAdjDetails,
  createRateAdminRateAdjustment,
  TestRateAdminRates,
  fetchExternalNetworkDD,
  fetchExternalRateTest,
  clearExternalRateTest,
  editRateAdminRates,
  fetchVehicleCategoryByLocation,
  fetchRevenuePreview,
  initCreateRateAdminRatesScreen,
} from "../../../redux/actions/RateAdmin/rateadminRates";
import {
  fetchLocationDD
} from "../../../redux/actions/location";
import {
  fetchRateAdminRateCodeDD
} from "../../../redux/actions/RateAdmin/rateadminRateCode";
import {
  fetchVehicleCategoryDD
} from "../../../redux/actions/vehicles/vehicleCategory";
import { setIsformDirty } from "../../../redux/actions/common/form";
import RateAdminRates from '../../../component/RateAdmin/RateAdminRates';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../../services/PostAPI';
import { APP_URLS } from '../../../utils/constant';
import { RateTypeDD } from '../../../component/RateAdmin/RateAdminRates/CreateRateAdminRates/constant';
import { FILTER } from '../../../services/common/urlService';
import { DATE_STRATEGY, formatDate } from '../../../utils/date';
function RateAdminRatesScreen(props) {
  const {
    fetchRateAdminRates,
    initRateAdminRatesScreen,
    initCreateRateAdminRatesScreen,
    showPageLevelLoader,
    rateAdminRatesListview,
    paginationInfo,
    screenPermissions,
    exportRateAdminRates,
    isRateAdminRatesExportError,
    isRateAdminRatesExportSuccess,
    fetchRateAdminRatesDD,
    deleteRateAdminRates,
    shouldOpenDeleteConfirmationPopup,
    setDeleteConfirmationPopupVisibility,
    isRateAdminRatesDeleteSuccess,
    isRateAdminRatesDeleteError,
    fetchLocationDD,
    locationDD,
    fetchRateAdminRateCodeDD,
    RateCodeDD,
    RatesDD,
    fetchVehicleCategoryDD,
    vehicleCategoryDD,
    fetchRateAdminNetworkDD,
    fetchRateAdminRateOptionsDD,
    RateOptionsDD,
    RateNetworkDD,
    isLoading,
    savedTableState,
    saveRatesTableState,
    fetchRateAdminRatesById,
    formFieldValueMap,
    isRateAdminRatesDetailSuccess,
    // Additional props for inline view
    fetchRateAdminRatesRateAdjDetails,
    createRateAdminRateAdjustment,
    TestRateAdminRates,
    fetchExternalNetworkDD,
    fetchExternalRateTest,
    clearExternalRateTest,
    shouldBlockNavigation,
    rateAdjustmentlist,
    RateTest,
    ExternalNetworkDD,
    ExternalRateTest,
    isExternalRateTestSuccess,
    isExternalRateTestError,
    isRateAdminRateAdjSuccess,
    isRateAdminRateAdjListSuccess,
    editRateAdminRates,
    isRateAdminRatesEditSuccess,
    isRateAdminRatesEditError,
    // Props for location-based categories
    fetchVehicleCategoryByLocation,
    vehicleCategoryByLocationDD,
    isVehicleCategoryByLocationSuccess,
    // Props for revenue preview
    fetchRevenuePreview,
    revenuePreviewData,
    isRevenuePreviewSuccess,
  } = props;
  const navigate = useNavigate();
  
  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined
    };
  };

  const callAPIasync = async () => {
    // Note: initRateAdminRatesScreen preserves savedTableState in reducer
    initRateAdminRatesScreen();

    await fetchRateAdminNetworkDD();
    await fetchRateAdminRateOptionsDD();
    await fetchRateAdminRatesDD();
    await fetchRateAdminRateCodeDD();
    await fetchLocationDD();
    await fetchVehicleCategoryDD();
    
    const savedLocationFilter = initialSavedState.current?.filters?.locationTitle?.value;
    if (savedLocationFilter) {
      await fetchVehicleCategoryByLocation({ locationId: savedLocationFilter });
    }
    
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      await fetchRateAdminRates(savedParams);
    } else {
      await fetchRateAdminRates({ sortField: 'id' });
    }
  }


  useEffect(() => {
    callAPIasync()
  }, []);
  
  const loadLazyData = (props) => {
    fetchRateAdminRates(props);
  };
  
  // Callback to save raw table state for restoration after navigation
  const handleTableStateChange = (rawParams) => {
    saveRatesTableState(rawParams);
  };
  
  const handleCreateRateAdminRates = () => {
    initCreateRateAdminRatesScreen();
    navigate(APP_URLS.RATEADMIN_RATES.CREATE);
  }
  const editRateAdminRatesRoute = (id) => {
    const path = generatePath(APP_URLS.RATEADMIN_RATES.EDIT, {
      id,
    });
    navigate(path);
  };
  const viewRateAdminRatesRoute = (id) => {
    const path = generatePath(APP_URLS.RATEADMIN_RATES.VIEW, {
      id,
    });
    navigate(path);
  };
  const copyRateAdminRatesRoute = (id) => {
    const path = generatePath(APP_URLS.RATEADMIN_RATES.COPY, {
      id,
    });
    navigate(path, { state: { returnUrl: APP_URLS.RATEADMIN_RATES.HOME } });
  };
  let nColumns = rateAdminRatesListview?.columns;
  if (nColumns && nColumns.length > 0) {
    let locDD = [];
    let rateCodeDD = [];
    let cateDD = [];
    let optDD = [];
    let netDD = [];
    let rtTypeDD = [];
    locationDD?.map(item => (
      locDD.push({ label: item.name, value: item.id })
    ))
    RateCodeDD?.map(item => (
      rateCodeDD.push({ label: item.name, value: item.id })
    ))

    vehicleCategoryByLocationDD?.map(item => (
      cateDD.push({ label: item.name, value: item.id })
    ))

    const isCategoryDisabled = !vehicleCategoryByLocationDD || vehicleCategoryByLocationDD.length === 0;

    RateOptionsDD?.map(item => (
      optDD.push({ label: item.name, value: item.id })
    ))
    RateNetworkDD?.map(item => (
      netDD.push({ label: item.name, value: item.id })
    ))
    RateTypeDD?.map(item => (
      rtTypeDD.push({ label: item.name, value: item.id })
    ))
    nColumns = nColumns?.map(item => ({
      ...item,
      ...(item.dataKey === "rateCodeTitle" ? { extraProps: { ...item.extraProps, options: rateCodeDD } } : {}),
      ...(item.dataKey === "locationTitle" ? { extraProps: { ...item.extraProps, options: locDD } } : {}),
      ...(item.dataKey === "networkTitle" ? { extraProps: { ...item.extraProps, options: netDD } } : {}),
      ...(item.dataKey === "categoryTitle" ? { extraProps: { ...item.extraProps, options: cateDD, disabled: isCategoryDisabled } } : {}),
      ...(item.dataKey === "rateOptionTitle" ? { extraProps: { ...item.extraProps, options: optDD } } : {}),
      ...(item.dataKey === "rateType" ? { extraProps: { ...item.extraProps, options: rtTypeDD } } : {})
    }));
  }
  const rateAdminRates = {
    handleCreateRateAdminRates,
    exportRateAdminRates,
    isRateAdminRatesExportError,
    isRateAdminRatesExportSuccess,
    deleteRateAdminRates,
    isRateAdminRatesDeleteSuccess,
    isRateAdminRatesDeleteError,
    editRateAdminRatesRoute,
    copyRateAdminRatesRoute,
    viewRateAdminRatesRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    fetchRateAdminRatess: loadLazyData,
    savedTableState,
    onTableStateChange: handleTableStateChange,
    fetchRateAdminRatesById,
    formFieldValueMap,
    isRateAdminRatesDetailSuccess,
    // Dropdown data for inline view
    RateCodeDD,
    locationDD,
    vehicleCategoryDD,
    RateOptionsDD,
    RateNetworkDD,
    // Additional props for inline view functionality
    fetchRateAdminRatesRateAdjDetails,
    createRateAdminRateAdjustment,
    TestRateAdminRates,
    fetchExternalNetworkDD,
    fetchExternalRateTest,
    clearExternalRateTest,
    shouldBlockNavigation,
    rateAdjustmentlist,
    RateTest,
    ExternalNetworkDD,
    ExternalRateTest,
    isExternalRateTestSuccess,
    isExternalRateTestError,
    isRateAdminRateAdjSuccess,
    isRateAdminRateAdjListSuccess,
    editRateAdminRates,
    isRateAdminRatesEditSuccess,
    isRateAdminRatesEditError,
    // Props for location-based categories
    fetchVehicleCategoryByLocation,
    vehicleCategoryByLocationDD,
    isVehicleCategoryByLocationSuccess,
    // Props for revenue preview
    fetchRevenuePreview,
    revenuePreviewData,
    isRevenuePreviewSuccess,
    tableData: {
      columns: nColumns,//rateAdminRatesListview?.columns,
      rows: rateAdminRatesListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <RateAdminRates
        {...rateAdminRates}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initRateAdminRatesScreen: () => dispatch(initializeRateAdminRatesScreen()),
    initCreateRateAdminRatesScreen: () => dispatch(initCreateRateAdminRatesScreen()),
    fetchRateAdminRates: (payload) => dispatch(fetchRateAdminRates(payload)),
    fetchRateAdminRatesDD: (payload) => dispatch(fetchRateAdminRatesDD(payload)),
    fetchRateAdminRateCodeDD: (payload) => dispatch(fetchRateAdminRateCodeDD(payload)),
    fetchRateAdminRateOptionsDD: (payload) => dispatch(fetchRateAdminRateOptionsDD(payload)),
    fetchRateAdminNetworkDD: (payload) => dispatch(fetchRateAdminNetworkDD(payload)),
    fetchLocationDD: (payload) => dispatch(fetchLocationDD(payload)),
    fetchVehicleCategoryDD: (payload) => dispatch(fetchVehicleCategoryDD(payload)),
    deleteRateAdminRates: (payload) => dispatch(deleteRateAdminRates(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportRateAdminRates: (payload) => dispatch(exportRateAdminRates(payload)),
    saveRatesTableState: (payload) => dispatch(saveRatesTableState(payload)),
    fetchRateAdminRatesById: (payload) => dispatch(fetchRateAdminRatesById(payload)),
    // Additional dispatch actions for inline view
    fetchRateAdminRatesRateAdjDetails: (payload) => dispatch(fetchRateAdminRatesRateAdjDetails(payload)),
    createRateAdminRateAdjustment: (payload) => dispatch(createRateAdminRateAdjustment(payload)),
    TestRateAdminRates: (payload) => dispatch(TestRateAdminRates(payload)),
    fetchExternalNetworkDD: (payload) => dispatch(fetchExternalNetworkDD(payload)),
    fetchExternalRateTest: (payload) => dispatch(fetchExternalRateTest(payload)),
    clearExternalRateTest: () => dispatch(clearExternalRateTest()),
    shouldBlockNavigation: (isFormDirty) => dispatch(setIsformDirty(isFormDirty)),
    editRateAdminRates: (payload) => dispatch(editRateAdminRates(payload)),
    fetchVehicleCategoryByLocation: (payload) => dispatch(fetchVehicleCategoryByLocation(payload)),
    fetchRevenuePreview: (payload) => dispatch(fetchRevenuePreview(payload)),
  };
};


//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {

    isRateAdminRatesCreateSuccess: selectFromRateAdminRatesReducer(
      state,
      "isRateAdminRatesCreateSuccess"
    ),
    shouldOpenDeleteConfirmationPopup: selectFromRateAdminRatesReducer(
      state,
      "shouldOpenDeleteConfirmationPopup"
    ),

    rateAdminRatesListview: selectFromRateAdminRatesReducer(
      state,
      "rateAdminRatesListview"
    ),
    showPageLevelLoader: selectFromRateAdminRatesReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromRateAdminRatesReducer(
      state,
      "paginationInfo"
    ),

    isRateAdminRatesDeleteSuccess: selectFromRateAdminRatesReducer(
      state,
      "isRateAdminRatesDeleteSuccess"
    ),
    isRateAdminRatesDeleteError: selectFromRateAdminRatesReducer(
      state,
      "isRateAdminRatesDeleteError"
    ),
    isPageLevelError: selectFromRateAdminRatesReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromRateAdminRatesReducer(
      state,
      "isFetchingGridData"
    ),
    isRateAdminRatesExportError: selectFromRateAdminRatesReducer(
      state,
      "isRateAdminRatesExportError"
    ),
    RateOptionsDD: selectFromRateAdminRatesReducer(
      state,
      "RateOptionsDD"
    ),
    RatesDD: selectFromRateAdminRatesReducer(
      state,
      "RatesDD"
    ),
    RateNetworkDD: selectFromRateAdminRatesReducer(
      state,
      "RateNetworkDD"
    ),
    isRateAdminRatesExportSuccess: selectFromRateAdminRatesReducer(
      state,
      "isRateAdminRatesExportSuccess"
    ),
    vehicleCategoryDD: selectFromVehicleVehicleCategoryReducer(
      state,
      "vehicleCategoryDD"
    ),
    locationDD: selectFromLocationReducer(
      state,
      "locationDD"
    ),
    RateCodeDD: selectFromRateCodeReducer(
      state,
      "RateCodeDD"
    ),
    savedTableState: selectFromRateAdminRatesReducer(
      state,
      "savedTableState"
    ),
    formFieldValueMap: selectFromRateAdminRatesReducer(
      state,
      "formFieldValueMap"
    ),
    isRateAdminRatesDetailSuccess: selectFromRateAdminRatesReducer(
      state,
      "isRateAdminRatesDetailSuccess"
    ),
    // Additional state for inline view
    rateAdjustmentlist: selectFromRateAdminRatesReducer(
      state,
      "rateAdjustmentlist"
    ),
    RateTest: selectFromRateAdminRatesReducer(state, "RateTest"),
    ExternalNetworkDD: selectFromRateAdminRatesReducer(state, "ExternalNetworkDD"),
    ExternalRateTest: selectFromRateAdminRatesReducer(state, "ExternalRateTest"),
    isExternalRateTestSuccess: selectFromRateAdminRatesReducer(state, "isExternalRateTestSuccess"),
    isExternalRateTestError: selectFromRateAdminRatesReducer(state, "isExternalRateTestError"),
    isRateAdminRateAdjSuccess: selectFromRateAdminRatesReducer(
      state,
      "isRateAdminRateAdjSuccess"
    ),
    isRateAdminRateAdjListSuccess: selectFromRateAdminRatesReducer(
      state,
      "isRateAdminRateAdjListSuccess"
    ),
    isRateAdminRatesEditSuccess: selectFromRateAdminRatesReducer(
      state,
      "isRateAdminRatesEditSuccess"
    ),
    isRateAdminRatesEditError: selectFromRateAdminRatesReducer(
      state,
      "isRateAdminRatesEditError"
    ),
    // Props for location-based categories
    vehicleCategoryByLocationDD: selectFromRateAdminRatesReducer(
      state,
      "vehicleCategoryByLocationDD"
    ),
    isVehicleCategoryByLocationSuccess: selectFromRateAdminRatesReducer(
      state,
      "isVehicleCategoryByLocationSuccess"
    ),
    // Props for revenue preview
    isLoading: selectFromRateAdminRatesReducer(
      state,
      "isLoading"
    ),
    revenuePreviewData: selectFromRateAdminRatesReducer(
      state,
      "revenuePreviewData"
    ),
    isRevenuePreviewSuccess: selectFromRateAdminRatesReducer(
      state,
      "isRevenuePreviewSuccess"
    ),
    ...ownProps,
  };
};

const selectFromRateAdminRatesReducer = (state, path) => {
  return selectRateAdminRatesReducer(state)[path];
};

const selectRateAdminRatesReducer = ({ rateadminRatesReducer }) => {
  return rateadminRatesReducer;
};

//Location
const selectFromRateCodeReducer = (state, path) => {
  return selectRateCodeReducer(state)[path];
};
const selectRateCodeReducer = ({ rateadminRateCodeReducer }) => {
  return rateadminRateCodeReducer;
};

//Location
const selectFromLocationReducer = (state, path) => {
  return selectLocationReducer(state)[path];
};
const selectLocationReducer = ({ locationReducer }) => {
  return locationReducer;
};

//Category
const selectFromVehicleVehicleCategoryReducer = (state, path) => {
  return selectVehicleVehicleCategoryReducer(state)[path];
};
const selectVehicleVehicleCategoryReducer = ({ vehicleCategoryReducer }) => {
  return vehicleCategoryReducer;
};
export default connect(mapStateToProps, mapDispatchToProps)(RateAdminRatesScreen);
